/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../../types/enums.js";

/**
 * |Token | Service name|
 *
 * @remarks
 * |:---|:---|
 * | dhl_express_domestic_express_doc | Domestic Express Doc|
 * | dhl_express_economy_select_doc | Economy Select Doc|
 * | dhl_express_worldwide_nondoc | Express Worldwide Nondoc|
 * | dhl_express_worldwide_doc | Express Worldwide Doc|
 * | dhl_express_worldwide | Worldwide|
 * | dhl_express_worldwide_eu_doc | Express Worldwide EU Doc|
 * | dhl_express_break_bulk_express_doc | Break Bulk Express Doc|
 * | dhl_express_express_9_00_nondoc | Express 9:00 NonDoc|
 * | dhl_express_economy_select_nondoc | Economy Select NonDoc|
 * | dhl_express_break_bulk_economy_doc | Break Bulk Economy Doc|
 * | dhl_express_express_9_00_doc | Express 9:00 Doc|
 * | dhl_express_express_10_30_doc | Express 10:30 Doc|
 * | dhl_express_express_10_30_nondoc | Express 10:30 NonDoc|
 * | dhl_express_express_12_00_doc | Express 12:00 Doc|
 * | dhl_express_europack_nondoc | Europack NonDoc|
 * | dhl_express_express_envelope_doc | Express Envelope Doc|
 * | dhl_express_express_12_00_nondoc | Express 12:00 NonDoc|
 * | dhl_express_express_12_doc | Domestic Express 12:00|
 * | dhl_express_worldwide_b2c_doc | Express Worldwide (B2C) Doc|
 * | dhl_express_worldwide_b2c_nondoc | Express Worldwide (B2C) NonDoc|
 * | dhl_express_medical_express | Medical Express|
 * | dhl_express_express_easy_nondoc | Express Easy NonDoc|
 */
export const ServiceLevelDHLExpressEnum = {
  DhlExpressDomesticExpressDoc: "dhl_express_domestic_express_doc",
  DhlExpressEconomySelectDoc: "dhl_express_economy_select_doc",
  DhlExpressWorldwideNondoc: "dhl_express_worldwide_nondoc",
  DhlExpressWorldwideDoc: "dhl_express_worldwide_doc",
  DhlExpressWorldwide: "dhl_express_worldwide",
  DhlExpressWorldwideEuDoc: "dhl_express_worldwide_eu_doc",
  DhlExpressBreakBulkExpressDoc: "dhl_express_break_bulk_express_doc",
  DhlExpressExpress900Nondoc: "dhl_express_express_9_00_nondoc",
  DhlExpressEconomySelectNondoc: "dhl_express_economy_select_nondoc",
  DhlExpressBreakBulkEconomyDoc: "dhl_express_break_bulk_economy_doc",
  DhlExpressExpress900Doc: "dhl_express_express_9_00_doc",
  DhlExpressExpress1030Doc: "dhl_express_express_10_30_doc",
  DhlExpressExpress1030Nondoc: "dhl_express_express_10_30_nondoc",
  DhlExpressExpress1200Doc: "dhl_express_express_12_00_doc",
  DhlExpressEuropackNondoc: "dhl_express_europack_nondoc",
  DhlExpressExpressEnvelopeDoc: "dhl_express_express_envelope_doc",
  DhlExpressExpress1200Nondoc: "dhl_express_express_12_00_nondoc",
  DhlExpressExpress12Doc: "dhl_express_express_12_doc",
  DhlExpressWorldwideB2cDoc: "dhl_express_worldwide_b2c_doc",
  DhlExpressWorldwideB2cNondoc: "dhl_express_worldwide_b2c_nondoc",
  DhlExpressMedicalExpress: "dhl_express_medical_express",
  DhlExpressExpressEasyNondoc: "dhl_express_express_easy_nondoc",
} as const;
/**
 * |Token | Service name|
 *
 * @remarks
 * |:---|:---|
 * | dhl_express_domestic_express_doc | Domestic Express Doc|
 * | dhl_express_economy_select_doc | Economy Select Doc|
 * | dhl_express_worldwide_nondoc | Express Worldwide Nondoc|
 * | dhl_express_worldwide_doc | Express Worldwide Doc|
 * | dhl_express_worldwide | Worldwide|
 * | dhl_express_worldwide_eu_doc | Express Worldwide EU Doc|
 * | dhl_express_break_bulk_express_doc | Break Bulk Express Doc|
 * | dhl_express_express_9_00_nondoc | Express 9:00 NonDoc|
 * | dhl_express_economy_select_nondoc | Economy Select NonDoc|
 * | dhl_express_break_bulk_economy_doc | Break Bulk Economy Doc|
 * | dhl_express_express_9_00_doc | Express 9:00 Doc|
 * | dhl_express_express_10_30_doc | Express 10:30 Doc|
 * | dhl_express_express_10_30_nondoc | Express 10:30 NonDoc|
 * | dhl_express_express_12_00_doc | Express 12:00 Doc|
 * | dhl_express_europack_nondoc | Europack NonDoc|
 * | dhl_express_express_envelope_doc | Express Envelope Doc|
 * | dhl_express_express_12_00_nondoc | Express 12:00 NonDoc|
 * | dhl_express_express_12_doc | Domestic Express 12:00|
 * | dhl_express_worldwide_b2c_doc | Express Worldwide (B2C) Doc|
 * | dhl_express_worldwide_b2c_nondoc | Express Worldwide (B2C) NonDoc|
 * | dhl_express_medical_express | Medical Express|
 * | dhl_express_express_easy_nondoc | Express Easy NonDoc|
 */
export type ServiceLevelDHLExpressEnum = ClosedEnum<
  typeof ServiceLevelDHLExpressEnum
>;

/** @internal */
export const ServiceLevelDHLExpressEnum$inboundSchema: z.ZodNativeEnum<
  typeof ServiceLevelDHLExpressEnum
> = z.nativeEnum(ServiceLevelDHLExpressEnum);

/** @internal */
export const ServiceLevelDHLExpressEnum$outboundSchema: z.ZodNativeEnum<
  typeof ServiceLevelDHLExpressEnum
> = ServiceLevelDHLExpressEnum$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ServiceLevelDHLExpressEnum$ {
  /** @deprecated use `ServiceLevelDHLExpressEnum$inboundSchema` instead. */
  export const inboundSchema = ServiceLevelDHLExpressEnum$inboundSchema;
  /** @deprecated use `ServiceLevelDHLExpressEnum$outboundSchema` instead. */
  export const outboundSchema = ServiceLevelDHLExpressEnum$outboundSchema;
}
